import { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '../components/Common/Snackbar';

const SnackbarContext = createContext();

export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within SnackbarProvider');
    }
    return context;
};

export const SnackbarProvider = ({ children }) => {
    const [snackbars, setSnackbars] = useState([]);

    const showSnackbar = useCallback((message, type = 'info', duration = 4000) => {
        const id = Date.now() + Math.random();
        const newSnackbar = { id, message, type, duration };
        setSnackbars(prev => [...prev, newSnackbar]);
        return id;
    }, []);

    const removeSnackbar = useCallback((id) => {
        setSnackbars(prev => prev.filter(snackbar => snackbar.id !== id));
    }, []);

    const success = useCallback((message, duration = 4000) => {
        return showSnackbar(message, 'success', duration);
    }, [showSnackbar]);

    const error = useCallback((message, duration = 5000) => {
        return showSnackbar(message, 'error', duration);
    }, [showSnackbar]);

    const warning = useCallback((message, duration = 4000) => {
        return showSnackbar(message, 'warning', duration);
    }, [showSnackbar]);

    const info = useCallback((message, duration = 4000) => {
        return showSnackbar(message, 'info', duration);
    }, [showSnackbar]);

    return (
        <SnackbarContext.Provider value={{ showSnackbar, success, error, warning, info, removeSnackbar }}>
            {children}
            <div className="snackbar-container">
                {snackbars.map((snackbar) => (
                    <Snackbar
                        key={snackbar.id}
                        message={snackbar.message}
                        type={snackbar.type}
                        duration={snackbar.duration}
                        onClose={() => removeSnackbar(snackbar.id)}
                    />
                ))}
            </div>
        </SnackbarContext.Provider>
    );
};
